module.exports = __webpack_public_path__ + "img/modelug_16.31eda220.jpg";